import isEqual from 'lodash/isEqual';
import { memo } from 'react';

import QuestionLibraryMapper from './mappers/QuestionLibraryMapper';

type QuestionLibraryBuilderProps = {
  questions?: any[];
  isParentShowing?: boolean;
};

/**
 * QuestionLibrary component that renders a list of questions.
 * @typedef {object} QuestionLibraryProps
 * @property {import('./types/question').QuestionProp[]} questions - An array of question objects to be rendered.
 *
 * @param {QuestionLibraryProps} props
 * @returns {JSX.Element} The rendered QuestionLibrary component.
 */
function QuestionLibraryBuilder({
  questions,
  isParentShowing = true,
}: Readonly<QuestionLibraryBuilderProps>) {
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      {questions.map((question) => (
        <QuestionLibraryMapper
          key={question.name}
          component={question}
          isParentShowing={isParentShowing}
        />
      ))}
    </div>
  );
}

export default memo(QuestionLibraryBuilder, (prevProps, nextProps) => {
  return (
    isEqual(prevProps.questions, nextProps.questions) &&
    prevProps.isParentShowing === nextProps.isParentShowing
  );
});
